import {
  talentCreate,
  talentItems,
  talentUpdate,
  talentDelete,
  talentDetails,
  talentSearch,
  talentCreateLabel,
  talentUploadsFile,
  talentPortrait,
  talentCreateEvaluation,
  talentCreateWork
} from '@/api/talent'

const talent = {
  state: {

  },
  mutations: {

  },
  actions: {
    TalentCreate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentCreate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentSearch ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentSearch(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentUpdate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentDelete ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentDelete(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentDetails ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentCreateWork ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentCreateWork(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentCreateLabel ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentCreateLabel(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentCreateEvaluation ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentCreateEvaluation(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentUploadsFile ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentUploadsFile(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TalentPortrait ({ commit }, data) {
      return new Promise((resolve, reject) => {
        talentPortrait(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default talent



// WEBPACK FOOTER //
// ./src/store/modules/talent.js